import { render, staticRenderFns } from "./RankingByCoursesGraphic.vue?vue&type=template&id=d6004c24"
import script from "./RankingByCoursesGraphic.vue?vue&type=script&lang=js"
export * from "./RankingByCoursesGraphic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports